import { HTTP } from '../../http-common'

export default {
  state: {
    loadedStates: []
  },
  getters: {
    loadedStates (state) {
      return state.loadedStates
    }
  },
  mutations: {
    setLoadedStates (state, payload) {
      state.loadedStates = payload
    },
    createState (state, payload) {
      state.loadedStates.push(payload)
    },
    updateState (state, payload) {
      state.loadedStates = state.loadedStates.map(_state => _state.id === payload.id ? payload : _state)
    },
    removeState (state, id) {
      state.loadedStates = state.loadedStates.filter(state => {
        return state.id !== id
      })
    },
    clearLoadedStates (state) {
      state.loadedStates = []
    }
  },
  actions: {
    loadStates ({ commit }) {
      commit('clearError')
      commit('setLoading', true)
      commit('setLoadedStates', [])

      return new Promise((resolve, reject) => {
        HTTP.get('state.json')
          .then(result => {
            console.log(result.data)
            commit('setLoadedStates', result.data.results)
            resolve(result.data)
          })
          .catch(err => {
            console.log(err)
            commit('setError', err)
            reject(err)
          })
          .finally(() => {
            commit('setLoading', false)
          })
      })
    },
    createState ({ commit, getters }, payload) {
      console.log('createState')
      commit('clearError')
      commit('setLoading', true)
      const newState = {
        description: payload.description
      }
      return new Promise((resolve, reject) => {
        HTTP.post('state.json/', newState)
          .then(result => {
            console.log(result)
            commit('createState', result.data)
            resolve(result)
          })
          .catch(err => {
            console.log(err)
            commit('setError', err)
            reject(err)
          })
          .finally(() => {
            commit('setLoading', false)
          })
      })
    },
    updateState ({ commit, getters }, payload) {
      console.log('updateState')
      commit('clearError')
      commit('setLoading', true)
      const state = {
        description: payload.description
      }
      return new Promise((resolve, reject) => {
        HTTP.patch(`state.json/${payload.id}/`, state)
          .then(result => {
            console.log(result)
            commit('updateState', result.data)
            resolve(result)
          })
          .catch(err => {
            console.log(err)
            commit('setError', err)
            reject(err)
          })
          .finally(() => {
            commit('setLoading', false)
          })
      })
    },
    removeState ({ commit }, payload) {
      console.log('removeState')
      commit('clearError')
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        HTTP.delete(`state.json/${payload}`)
          .then(result => {
            console.log('result', result)
            commit('removeState', payload)
            resolve(result)
          })
          .catch(err => {
            console.log(err)
            commit('setError', err)
            reject(err)
          })
          .finally(() => {
            commit('setLoading', false)
          })
      })
    },
    clearLoadedStates ({ commit }) {
      commit('clearLoadedStates')
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/state/index.js